/* FN_W est publiee par layout/theme.liquid : elle redimensionne via le CDN
   Shopify (parametre width) ou via les variantes locales selon l'origine. */
var FN_W = window.FN_W || function (u, px) { return u; };

/* ============================================================
   FRAISE NOIRE — LE NUANCIER
   Les casquettes filtrées par couleur. Mapping ÉTABLI PAR
   VÉRIFICATION VISUELLE des 29 photos (les titres décrivent
   souvent la broderie, pas la toile).
   Zéro dépendance dure : tout est gardé par la présence des
   éléments dans la page.
   ============================================================ */
(() => {
  'use strict';
  const PRODUCTS = window.FN_PRODUCTS || [];
  const media = (s, a, t) => (window.FN && window.FN.media) ? window.FN.media(s, a, t) : `<img src="${s}" ${a}>`;
  if (!PRODUCTS.length) return;
  const eur = n => n.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  const esc = s => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
  const find = h => PRODUCTS.find(p => p.handle === h);

  /* ================= LE NUANCIER ================= */
  const nuSwatches = document.getElementById('nuSwatches');
  const nuGrid = document.getElementById('nuGrid');
  if (nuSwatches && nuGrid) {
    /* Couleur dominante de chaque pièce (toile OU broderie signature),
       vérifiée photo par photo — ex. « Fraise Menthe » = casquette noire
       à fraise menthe, « Brodée 3D White » = casquette blanche. */
    const NU_COLORS = [
      { k: 'noir',   label: 'Noir',      sw: '#141414',
        h: ['casquette-ajustable-black-zefrai-fraise-noire-2023', 'casquette-ajustable-rien-100-rien-fraise-noire-2023', 'casquette-ajustable-style-trucker-fraise-noire-2023', 'casquette-brodee-3d-ajustable-black', 'casquette-noire-ajustable-style-trucker-fraise-noire-2023', 'casquette-fraise-noire-pailletee', 'casquette-fraise-gold'] },
      { k: 'blanc',  label: 'Blanc',     sw: '#F5F4F2',
        h: ['casquette-brodee-3d-ajustable-white', 'casquette-blanche-ajustable-style-trucker-fraise-noire-2023', 'casquette-blanche-fraise-noire', 'casquette-blanche-fraise-turquoise'] },
      { k: 'gris',   label: 'Gris',      sw: '#9A9A9A',
        h: ['casquette-ajustable-classics-black-copie', 'casquette-ajustable-classics-black-copie-1'] },
      { k: 'rouge',  label: 'Rouge',     sw: '#16161A',
        h: ['casquette-rouge-ajustable-style-trucker-fraise-noire-2023', 'casquette-rouge-fraise-argent'] },
      { k: 'rose',   label: 'Rose',      sw: '#E8A0B4',
        h: ['casquette-brodee-3d-ajustable-classics-pink', 'casquette-ajustable-classics-pink', 'casquette-fraise-rose-paillettes'] },
      { k: 'bleu',   label: 'Bleu',      sw: '#2E5C8A',
        h: ['casquette-ajustable-blue-magic', 'casquette-abeille-bleue', 'casquette-ajustable-classics-blue-navy'] },
      { k: 'vert',   label: 'Vert',      sw: '#5B6B4A',
        h: ['casquette-kaki-ajustable-style-trucker-fraise-noire-2023', 'casquette-ajustable-classics-black-copie-2', 'casquette-fraise-menthe', 'casquette-kaki-fraise-fluo'] },
      { k: 'orange', label: 'Orange',    sw: '#E8742C',
        h: ['casquette-abeille-orange'] },
      { k: 'or',     label: 'Or & holo', sw: 'linear-gradient(135deg,#D8B25C 0%,#EDE6F2 60%,#C9C4CE 100%)',
        h: ['casquette-fraise-gold-hologramme', 'casquette-fraise-hologramme'] },
      { k: 'beige',  label: 'Beige',     sw: '#D8CDBB',
        h: ['casquette-ajustable-classics-wood'] },
    ];
    const caps = PRODUCTS.filter(p => p.cat === 'Casquettes' && p.img);
    const capCount = caps.length;
    /* Vitrine « Toutes » : ordre curaté par familles (même logique que le
       rail casquettes : Brodée 3D → Or/Holo → Paillettes → Abeille → lettrages) */
    const DEFAULT_ORDER = [
      'casquette-brodee-3d-ajustable-black', 'casquette-brodee-3d-ajustable-white',
      'casquette-brodee-3d-ajustable-classics-pink', 'casquette-fraise-gold',
      'casquette-fraise-hologramme', 'casquette-fraise-noire-pailletee',
      'casquette-fraise-menthe', 'casquette-abeille-orange',
      'casquette-ajustable-rien-100-rien-fraise-noire-2023', 'casquette-rouge-fraise-argent',
    ];
    const mkCard = (window.FN && window.FN.card) ? window.FN.card : (p => `
      <article class="card">
        <div class="card__media">
          ${media(p.img, `class="card__img card__img--front" alt="${esc(p.title)}" width="928" height="1152" loading="lazy"`, "(max-width:760px) 50vw, 25vw")}
          <a class="card__link" href="${p.url || "/products/" + p.handle}" aria-label="${esc(p.title)}"></a>
        </div>
        <div class="card__info">
          <div><span class="card__name">${esc(p.title)}</span><span class="card__cat">${esc(p.cat)}</span></div>
          <span class="card__price tabular">${eur(p.price)}</span>
        </div>
      </article>`);
    const countEl = document.querySelector('[data-nu-count]');

    function render(key) {
      const col = NU_COLORS.find(c => c.k === key);
      const list = col
        ? col.h.map(find).filter(Boolean)
        : DEFAULT_ORDER.map(find).filter(Boolean);
      const shown = list.slice(0, 10);
      const more = `
        <a class="nu-more" href="/collections/casquettes">
          <span class="nu-more__n tabular">${capCount}</span>
          <span class="nu-more__t">Toutes les casquettes <span aria-hidden="true">→</span></span>
        </a>`;
      nuGrid.innerHTML = shown.map(mkCard).join('') + more;
      if (countEl) {
        countEl.textContent = col
          ? `${list.length} ${list.length > 1 ? 'pièces' : 'pièce'} · ${col.label.toLowerCase()}`
          : `${capCount} casquettes, une pastille par teinte`;
      }
    }

    /* Pastilles — chaque pastille matche au moins 1 produit réel (vérifié) */
    const swatches = [{ k: 'toutes', label: 'Toutes', sw: 'conic-gradient(#141414 0 25%, #16161A 0 50%, #D8B25C 0 75%, #2E5C8A 0 100%)' }]
      .concat(NU_COLORS.filter(c => c.h.map(find).filter(Boolean).length > 0));
    nuSwatches.innerHTML = swatches.map((c, i) => `
      <button class="nu-swatch" type="button" data-nu="${c.k}" aria-pressed="${i === 0 ? 'true' : 'false'}">
        <span class="nu-swatch__dot" style="--sw:${c.sw}" aria-hidden="true"></span>
        <span class="nu-swatch__lbl">${c.label}</span>
      </button>`).join('');

    let fadeTimer = null;
    nuSwatches.addEventListener('click', e => {
      const btn = e.target.closest('[data-nu]');
      if (!btn || btn.getAttribute('aria-pressed') === 'true') return;
      nuSwatches.querySelectorAll('[data-nu]').forEach(b => b.setAttribute('aria-pressed', String(b === btn)));
      const key = btn.dataset.nu === 'toutes' ? null : btn.dataset.nu;
      nuGrid.classList.add('is-fading');
      clearTimeout(fadeTimer);
      fadeTimer = setTimeout(() => {
        render(key);
        nuGrid.classList.remove('is-fading');
      }, 180);
    });

    render(null);
  }
})();

/* ================= LE SCEAU DU JOUR + LES DUOS SCELLÉS ================= */
(() => {
  'use strict';
  const media = (s, a, t) => (window.FN && window.FN.media) ? window.FN.media(s, a, t) : `<img src="${s}" ${a}>`;
  const P = window.FN_PRODUCTS || [];
  if (!P.length) return;
  const eur = n => n.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  const esc = s => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
  const find = h => P.find(p => p.handle === h);
  /* L'adresse d'une fiche produit sur Shopify est `/products/<handle>`.
     `/products/?handle=x` est un reste de la V2 locale : sur la boutique, cette
     adresse ne mene a aucun produit — elle tombe sur la liste des collections
     (signale par Hedy le 2026-10-07 depuis la section des duos).
     `p.url` est l'adresse donnee par Shopify ; le repli reste utile si le
     catalogue ne la fournit pas. */
  const pdp = h => `/products/${encodeURIComponent(h)}`;

  /* ---- LE SCEAU DU JOUR : sélection déterministe quotidienne ---- */
  const sjImg = document.getElementById('sjImg');
  if (sjImg) {
    const pool = P.filter(p => p.available && p.img);
    const N = pool.length;

    /* Le quantième de l'année, calculé sur l'heure LOCALE : c'est à minuit chez
       le visiteur que la pièce doit changer, pas à minuit UTC. */
    const quantieme = dt => {
      const a = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
      return Math.round((a - new Date(dt.getFullYear(), 0, 0)) / 86400000);
    };

    /* Un simple `doy % N` déroulait le catalogue dans l'ordre du fichier : sept
       casquettes d'affilée, puis sept t-shirts. On avance d'un PAS premier avec
       N — la suite parcourt alors les N pièces sans jamais en répéter une avant
       d'avoir fait le tour, mais en sautant d'un univers à l'autre.
       Le pas est cherché à l'exécution : si le catalogue change de taille, une
       valeur écrite en dur pourrait ne plus être première avec N et la rotation
       se replierait sur une poignée de pièces. */
    const pgcd = (a, b) => b ? pgcd(b, a % b) : a;
    const PAS = (() => { for (let k = 31; k < 31 + N; k++) if (pgcd(k % N || N, N) === 1) return k; return 1; })();
    const pieceDu = doy => pool[(((doy * PAS) % N) + N) % N];

    const p = pieceDu(quantieme(new Date()));
    let size = null;

    /* ---- la pièce du jour ---- */
    const grandFormat = src => {
      const w = FN_W(src, 1200);
      return w !== src ? w : src;
    };
    const poser = (src, alt) => {
      const w = grandFormat(src);
      if (w !== src) { sjImg.onerror = () => { sjImg.onerror = null; sjImg.src = src; }; sjImg.src = w; }
      else sjImg.src = src;
      sjImg.alt = alt;
    };
    poser(p.img, p.title);
    document.getElementById('sjTitle').textContent = p.title;
    document.getElementById('sjPrice').textContent = eur(p.price);
    document.getElementById('sjCat').textContent = p.cat || '';
    document.getElementById('sjMedia').href = pdp(p.handle);
    document.getElementById('sjLink').href = pdp(p.handle);

    /* ---- face / dos, quand la pièce a une seconde vue ---- */
    const vues = document.getElementById('sjVues');
    if (vues && p.img2) {
      const VUES = [{ t: 'Face', s: p.img }, { t: 'Dos', s: p.img2 }];
      vues.hidden = false;
      vues.innerHTML = VUES.map((v, i) =>
        `<button class="sj__vue${i ? '' : ' is-on'}" type="button" data-sj-vue="${i}">${v.t}</button>`).join('');
      vues.addEventListener('click', e => {
        const b = e.target.closest('[data-sj-vue]');
        if (!b) return;
        const v = VUES[+b.dataset.sjVue];
        poser(v.s, `${p.title} — ${v.t.toLowerCase()}`);
        vues.querySelectorAll('.sj__vue').forEach(x => x.classList.toggle('is-on', x === b));
      });
    }

    /* ---- tailles ---- */
    const sizesBox = document.getElementById('sjSizes');
    if (p.sizes && p.sizes.length) {
      size = p.sizes.includes('M') ? 'M' : p.sizes[0];
      sizesBox.innerHTML = p.sizes.map(s =>
        `<button class="sj__size${s === size ? ' is-on' : ''}" data-sj-size="${esc(s)}" type="button">${esc(s)}</button>`).join('');
      sizesBox.addEventListener('click', e => {
        const b = e.target.closest('[data-sj-size]');
        if (!b) return;
        size = b.dataset.sjSize;
        sizesBox.querySelectorAll('.sj__size').forEach(x => x.classList.toggle('is-on', x === b));
      });
    }
    document.getElementById('sjAdd').addEventListener('click', () => {
      window.FN && window.FN.addToCart && window.FN.addToCart(p.handle, size);
    });

    /* ---- la série des jours précédents ---- */
    const frise = document.getElementById('sjFrise');
    if (frise) {
      const aujourdhui = quantieme(new Date());
      frise.innerHTML = Array.from({ length: 6 }, (_, k) => {
        const q = pieceDu(aujourdhui - (k + 1));
        const jour = new Date();
        jour.setDate(jour.getDate() - (k + 1));
        /* Le jour de la semaine plutôt que « il y a 5 jours » : c'est plus court
           (les libellés longs se faisaient tronquer dans 86 px) et plus concret. */
        const nom = jour.toLocaleDateString('fr-FR', { weekday: 'long' });
        const quand = k === 0 ? 'Hier' : nom.charAt(0).toUpperCase() + nom.slice(1);
        return `<a class="sj__jour" href="${pdp(q.handle)}" title="${esc(q.title)} — ${esc(eur(q.price))}">`
          + `<span class="sj__jour-img">${media(q.img, `alt="${esc(q.title)}" loading="lazy"`, '120px')}</span>`
          + `<span class="sj__jour-quand">${esc(quand)}</span>`
          + `<span class="sj__jour-prix tabular">${esc(eur(q.price))}</span></a>`;
      }).join('');
    }

    /* ---- le compte à rebours jusqu'à minuit ---- */
    const bH = document.getElementById('sjH'), bM = document.getElementById('sjM'), bS = document.getElementById('sjS');
    const a11y = document.getElementById('sjChronoA11y');
    if (bH && bM && bS) {
      const deux = n => String(n).padStart(2, '0');
      let dernierJour = quantieme(new Date());
      const battre = () => {
        const n = new Date();
        const minuit = new Date(n.getFullYear(), n.getMonth(), n.getDate() + 1);
        const reste = Math.max(0, minuit - n);
        const h = Math.floor(reste / 3600000);
        const m = Math.floor(reste / 60000) % 60;
        const s = Math.floor(reste / 1000) % 60;
        // on ne réécrit que ce qui change : sinon l'animation du chiffre
        // se rejouerait sur les heures et les minutes à chaque seconde
        const maj = (el, v) => { if (el.textContent !== v) { el.textContent = v; el.classList.remove('bat'); void el.offsetWidth; el.classList.add('bat'); } };
        maj(bH, deux(h)); maj(bM, deux(m)); maj(bS, deux(s));
        // le lecteur d'écran reçoit une mise à jour par minute, pas par seconde
        if (a11y && s === 0) a11y.textContent = `${h} heures et ${m} minutes avant la pièce suivante.`;
        // minuit franchi pendant que l'onglet était ouvert : on recharge la sélection
        if (quantieme(n) !== dernierJour) { dernierJour = quantieme(n); location.reload(); }
      };
      battre();
      setInterval(battre, 1000);
    }
  }

  /* ---- LES DUOS SCELLÉS : paires éditorialisées ---- */
  const duosGrid = document.getElementById('duosGrid');
  if (duosGrid) {
    const DUOS = [
      { nom: 'Le duo Mars', a: 'hoodies-design-a-capuche-13mars', b: 'casquette-brodee-3d-ajustable-white' },
      { nom: 'Le duo Doodle', a: 'ensemble-t-shirt-short-doodle-noir', b: 'casquette-fraise-noire-pailletee' },
      { nom: "Le duo Été", a: 't-shirt-the-ruche-blanc', b: 'short-de-bain-ciel' },
    ];
    const state = {};
    duosGrid.innerHTML = DUOS.map((d, i) => {
      const A = find(d.a), B = find(d.b);
      if (!A || !B) return '';
      const total = A.price + B.price;
      const sized = [A, B].filter(p => p.sizes && p.sizes.length);
      state[i] = sized.length ? 'M' : null;
      return `<article class="duo" data-duo="${i}">
        <div class="duo__imgs">
          <a href="${pdp(A.handle)}">${media(A.img, `alt="${esc(A.title)}" loading="lazy" width="600" height="750"`, '(max-width:900px) 45vw, 22vw')}</a>
          <a href="${pdp(B.handle)}">${media(B.img, `alt="${esc(B.title)}" loading="lazy" width="600" height="750"`, '(max-width:900px) 45vw, 22vw')}</a>
        </div>
        <div><span class="duo__name">${esc(d.nom)}</span>
        <p class="duo__pieces">${esc(A.title)} · ${eur(A.price)}<br>${esc(B.title)} · ${eur(B.price)}</p></div>
        <div class="duo__foot">
          ${sized.length ? `<div class="duo__sizes">${['S','M','L','XL'].map(s =>
            `<button class="duo__size${s === 'M' ? ' is-on' : ''}" data-duo-size="${s}" type="button">${s}</button>`).join('')}</div>` : ''}
          <div class="duo__row">
            <span class="duo__total tabular">${eur(total)}</span>
            <span class="duo__ship">Livraison offerte</span>
          </div>
          <button class="btn btn--solid btn--full" data-duo-add type="button">Ajouter le duo</button>
        </div>
      </article>`;
    }).join('');
    duosGrid.addEventListener('click', e => {
      const card = e.target.closest('[data-duo]');
      if (!card) return;
      const i = +card.dataset.duo;
      const sz = e.target.closest('[data-duo-size]');
      if (sz) {
        state[i] = sz.dataset.duoSize;
        card.querySelectorAll('.duo__size').forEach(x => x.classList.toggle('is-on', x === sz));
        return;
      }
      if (e.target.closest('[data-duo-add]')) {
        const d = DUOS[i];
        [find(d.a), find(d.b)].forEach(p => {
          window.FN && window.FN.addToCart && window.FN.addToCart(p.handle, (p.sizes && p.sizes.length) ? state[i] : null);
        });
      }
    });
  }
})();
